import EditQr from "../pages/editQr";
import Login from "../pages/login";
import GenerateLinks from "../pages/generateLinks";
import Register from "../pages/register";
import BarcodeLists from "../pages/barcodeLists";
import EditProfile from "../pages/editProfile";
import ForgotPassword from "../pages/forgot-password";
import InfoPage from "../pages/infoPage";
import ImageVideosInfoPage from "../pages/imageVideosInfoPage";

const Admin = ["admin"];
const User = ["user"];
const All = ["admin", "user"];

const routes = [
  {
    path: "/",
    Component: BarcodeLists,
    role: User,
    secure: true,
    mixLayout: false,
  },
  {
    path: "/edit/:id",
    Component: EditQr,
    role: User,
    secure: true,
    mixLayout: false,
  },
  {
    path: "/profile",
    Component: EditProfile,
    role: All,
    secure: true,
    mixLayout: false,
  },
  {
    path: "/info/:id",
    Component: InfoPage,
    role: All,
    secure: false,
    mixLayout: true,
  },
  {
    path: "/image-videos/:id",
    Component: ImageVideosInfoPage,
    role: All,
    secure: false,
    mixLayout: true,
  },
  {
    path: "/login",
    Component: Login,
    secure: false,
    mixLayout: false,
  },
  {
    path: "/reset",
    Component: ForgotPassword,
    secure: false,
    mixLayout: false,
  },
  {
    path: "/register",
    Component: Register,
    secure: false,
    mixLayout: false,
  },
  {
    path: "/admin",
    Component: GenerateLinks,
    role: Admin,
    secure: true,
    mixLayout: false,
  },
];

export default routes;
